import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _589f8c98 = () => interopDefault(import('../../../app/pages/invoicing/index.vue' /* webpackChunkName: "pages/invoicing/index" */))
const _f5f3bb1a = () => interopDefault(import('../../../app/pages/missions/index.vue' /* webpackChunkName: "pages/missions/index" */))
const _f492f606 = () => interopDefault(import('../../../app/pages/onboarding-revamp/index.vue' /* webpackChunkName: "pages/onboarding-revamp/index" */))
const _11bbad39 = () => interopDefault(import('../../../app/pages/qualification/index.vue' /* webpackChunkName: "pages/qualification/index" */))
const _4bdc0066 = () => interopDefault(import('../../../app/pages/upload/index.vue' /* webpackChunkName: "pages/upload/index" */))
const _183262ba = () => interopDefault(import('../../../app/pages/auth/change-password.vue' /* webpackChunkName: "pages/auth/change-password" */))
const _8fb6d3ea = () => interopDefault(import('../../../app/pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _ce6fcf34 = () => interopDefault(import('../../../app/pages/auth/signup.vue' /* webpackChunkName: "pages/auth/signup" */))
const _c1695406 = () => interopDefault(import('../../../app/pages/auth/tos/index.vue' /* webpackChunkName: "pages/auth/tos/index" */))
const _41803389 = () => interopDefault(import('../../../app/pages/invoicing/forecast.vue' /* webpackChunkName: "pages/invoicing/forecast" */))
const _92af4600 = () => interopDefault(import('../../../app/pages/missions/map/index.vue' /* webpackChunkName: "pages/missions/map/index" */))
const _02efee9a = () => interopDefault(import('../../../app/pages/missions/search/index.vue' /* webpackChunkName: "pages/missions/search/index" */))
const _57939539 = () => interopDefault(import('../../../app/pages/preferences/documents-revamp/index.vue' /* webpackChunkName: "pages/preferences/documents-revamp/index" */))
const _34b918ec = () => interopDefault(import('../../../app/pages/preferences/legal/index.vue' /* webpackChunkName: "pages/preferences/legal/index" */))
const _3a571ddc = () => interopDefault(import('../../../app/pages/preferences/profile/index.vue' /* webpackChunkName: "pages/preferences/profile/index" */))
const _34cd4c2a = () => interopDefault(import('../../../app/pages/qualification/success.vue' /* webpackChunkName: "pages/qualification/success" */))
const _51fcfc9e = () => interopDefault(import('../../../app/pages/auth/verify-email/pending.vue' /* webpackChunkName: "pages/auth/verify-email/pending" */))
const _2d8f5e17 = () => interopDefault(import('../../../app/pages/preferences/legal/revamp.vue' /* webpackChunkName: "pages/preferences/legal/revamp" */))
const _76b64592 = () => interopDefault(import('../../../app/pages/auth/reset-password/_token.vue' /* webpackChunkName: "pages/auth/reset-password/_token" */))
const _5daeb67a = () => interopDefault(import('../../../app/pages/auth/verify-email/_token.vue' /* webpackChunkName: "pages/auth/verify-email/_token" */))
const _1fad5a9f = () => interopDefault(import('../../../app/pages/invoicing/_id/index.vue' /* webpackChunkName: "pages/invoicing/_id/index" */))
const _235a6844 = () => interopDefault(import('../../../app/pages/missions/_id/index.vue' /* webpackChunkName: "pages/missions/_id/index" */))
const _0470dd16 = () => interopDefault(import('../../../app/pages/upload/_id.vue' /* webpackChunkName: "pages/upload/_id" */))
const _12367492 = () => interopDefault(import('../../../app/pages/missions/_id/_checkin.vue' /* webpackChunkName: "pages/missions/_id/_checkin" */))
const _04f2e799 = () => interopDefault(import('../../../app/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _18d7213e = () => interopDefault(import('../../../app/pages/_pending.vue' /* webpackChunkName: "pages/_pending" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/invoicing",
    component: _589f8c98,
    name: "invoicing"
  }, {
    path: "/missions",
    component: _f5f3bb1a,
    name: "missions"
  }, {
    path: "/onboarding-revamp",
    component: _f492f606,
    name: "onboarding-revamp"
  }, {
    path: "/qualification",
    component: _11bbad39,
    name: "qualification"
  }, {
    path: "/upload",
    component: _4bdc0066,
    name: "upload"
  }, {
    path: "/auth/change-password",
    component: _183262ba,
    name: "auth-change-password"
  }, {
    path: "/auth/login",
    component: _8fb6d3ea,
    name: "auth-login"
  }, {
    path: "/auth/signup",
    component: _ce6fcf34,
    name: "auth-signup"
  }, {
    path: "/auth/tos",
    component: _c1695406,
    name: "auth-tos"
  }, {
    path: "/invoicing/forecast",
    component: _41803389,
    name: "invoicing-forecast"
  }, {
    path: "/missions/map",
    component: _92af4600,
    name: "missions-map"
  }, {
    path: "/missions/search",
    component: _02efee9a,
    name: "missions-search"
  }, {
    path: "/preferences/documents-revamp",
    component: _57939539,
    name: "preferences-documents-revamp"
  }, {
    path: "/preferences/legal",
    component: _34b918ec,
    name: "preferences-legal"
  }, {
    path: "/preferences/profile",
    component: _3a571ddc,
    name: "preferences-profile"
  }, {
    path: "/qualification/success",
    component: _34cd4c2a,
    name: "qualification-success"
  }, {
    path: "/auth/verify-email/pending",
    component: _51fcfc9e,
    name: "auth-verify-email-pending"
  }, {
    path: "/preferences/legal/revamp",
    component: _2d8f5e17,
    name: "preferences-legal-revamp"
  }, {
    path: "/auth/reset-password/:token?",
    component: _76b64592,
    name: "auth-reset-password-token"
  }, {
    path: "/auth/verify-email/:token?",
    component: _5daeb67a,
    name: "auth-verify-email-token"
  }, {
    path: "/invoicing/:id",
    component: _1fad5a9f,
    name: "invoicing-id"
  }, {
    path: "/missions/:id",
    component: _235a6844,
    name: "missions-id"
  }, {
    path: "/upload/:id",
    component: _0470dd16,
    name: "upload-id"
  }, {
    path: "/missions/:id/:checkin",
    component: _12367492,
    name: "missions-id-checkin"
  }, {
    path: "/",
    component: _04f2e799,
    name: "index"
  }, {
    path: "/:pending",
    component: _18d7213e,
    name: "pending"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
